<template>
  <section class="scrollable padder">
    <div v-if="loading" class="loading">Loading&#8230;</div>
    <div v-if="showAlert" class="alert alert-danger alert-dismissible">
      <button
        type="button"
        class="close"
        aria-hidden="true"
        @click="closeAlert"
      >
        ×
      </button>
      <h4><i class="icon fa fa-ban"></i> Error!</h4>
      {{ errMessage }}
    </div>
    <section class="panel panel-default">
     
      <div class="modal-body">
        <ValidationObserver v-slot="{ handleSubmit }">
        <form @submit.prevent="handleSubmit(addEdit)" method="post">
            
          <div class="col-sm-12">
             <ValidationProvider
               name="Payment Term"
                  rules="required"
                  v-slot="{ errors }"
               >
            <div class="form-group">
              <label for="category">
                Payment Term <span class="required-color">*</span></label
              >
              <input
                type="text"
                id="term_name"
                class="form-control"
                v-model="termName"
                autocomplete="off"
                data-parsley-pattern-message="This is not a valid Payment Term"
                data-parsley-trigger="keyup"
                value=""
                placeholder="Payment Term"
              />
               <span style="color:red">{{ errors[0] }}</span>
            </div>
          
                </ValidationProvider>
          </div>

          <div class="modal-footer" style="text-align: right">
           
            <button
              :disabled="saveCat"
              id="btn_save"
              type="submit"
              class="btn btn-success  text-center  "
            >
              Save
            </button>
             <a
              v-on:click="$emit('hide-form')"
              class="btn btn-danger  text-center  "
            >
              Close
            </a>
          </div>
        </form>
        </ValidationObserver>
      </div>
      
    </section>
  </section>
</template>

<script>
import api from "../api";

export default {
  props: ["termId"],
  name: "AddPaymentTerm",
  data() {
    return {
      saveCat: false,
      term_id: '',
      termList: [],
      errors : [],
      termName: "",
      loading: false,
    };
  },
  methods: {
    addEdit() {
       this.loading = false
      this.saveCat = true;
      this.term_id = this.$props.termId;
      this.errors = []
      if (!this.termName) {
        this.errors.push("Payment Term required.");
      }
      if(!this.errors.length){
      const addForm = {
        "term-form": {
          term_id: this.term_id,
          term_name: this.termName
        },
      };
      if (this.term_id > 0) {
        api
          .request("post", "GeneralApis/edit_payment_term", addForm)
          .then((response) => {
            var data = response.data;
            if (data.errorcode) {
              this.response = data.errormessage;
              return;
            } else {
              alert("Succesfully Updated");
              this.$emit("hide-form");
              this.$emit("list-items");
            }
          });
      } else {
        api
          .request("post", "GeneralApis/add_payment_term", addForm)
          .then((response) => {
            var data = response.data;
            if (data.errorcode) {
              this.response = data.errormessage;
              return;
            } else {
              alert("Succesfully Added");
              this.$emit("hide-form");
              this.$emit("list-items");
            }
          });
      }
      }
    },
    getList: function() {
      var id = this.$props.termId;
      (this.termList = []),
        (this.termName = ""),
        (this.term_id = 0);
      if (id > 0) {
        this.term_id = id;

        const getlist = {
          filter: {
            term_id: this.term_id,
          },
        };
        api
          .request("post", "GeneralApis/get_payment_terms", getlist)
          .then((response) => {
            var data = response.data;
            if (data.errorcode) {
              this.response = data.errormessage;
              return;
            } else {
              this.termList = data.termList[0];
              this.termName = this.termList.term_name;
            }
          });
      }
    },
  },
  mounted() {
    this.getList();
  },
};
</script>
